<template></template>

<script setup lang="ts">
  import { FilterMatchMode } from "primevue/api";
  import { defineColumnFilter, defineColumnProps } from "../../lib/defines";

  defineExpose(
    Object.assign(
      {},
      defineColumnProps({
        sortable: true,
        dataType: "date",
        showClearButton: false,
        showApplyButton: false,
      }),
      defineColumnFilter({
        matchMode: FilterMatchMode.DATE_BEFORE,
      }),
    ),
  );
</script>

<style scoped></style>
